"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_demi_1 = require("vue-demi");
const fego_render_1 = require("@futuweb/fego-render");
const __sfc_main = {};
__sfc_main.props = {
    imageUrl: {
        key: "imageUrl",
        required: true,
        type: String
    },
    duration: {
        key: "duration",
        required: true,
        type: Number
    },
    statusParam: {
        key: "statusParam",
        required: false,
        type: String
    }
};
__sfc_main.setup = (__props, __ctx) => {
    const { variable } = fego_render_1.store;
    const props = __props;
    const emit = __ctx.emit;
    const timer = (0, vue_demi_1.ref)(null);
    const isPreRender = window.__PRE_RENDERING__ || location.search.includes('pre_rendering');
    const updateStatus = (value) => {
        if (props.statusParam) {
            variable.data[props.statusParam] = value;
        }
    };
    const handleLoad = () => {
        if (isPreRender) {
            return;
        }
        timer.value = setTimeout(() => {
            updateStatus('0');
            emit('basic-animation_end');
        }, props.duration);
    };
    const handleError = (e) => {
        console.error('Animation image load failed:', e);
        emit('basic-animation_error', e);
    };
    (0, vue_demi_1.onMounted)(() => {
        if (isPreRender) {
            return;
        }
        updateStatus('1');
        emit('basic-animation_start');
    });
    (0, vue_demi_1.onBeforeUnmount)(() => {
        if (timer.value) {
            clearTimeout(timer.value);
            timer.value = null;
        }
    });
    return {
        props,
        handleLoad,
        handleError
    };
};
exports.default = __sfc_main;
//# sourceMappingURL=data:application/json;base64,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